/**
 * Boxes as printed on ICS 232A-CG (Jan 2026), Area Contingency Plan Site
 * Index.
 */
export const ICS232A_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  siteIndex:
    '4. Index to Area Contingency Plan (ACP) or Geographic Response Plan (GRP) sites on Situation Map:',
  preparedBy: '5. Prepared by:',
} as const;

/** Columns of box 4. */
export const ICS232A_SITE_COLUMNS = [
  { key: 'site_number', label: 'Site #' },
  { key: 'priority', label: 'Priority' },
  { key: 'site_name_location', label: 'Site Name and/or Physical Location' },
  { key: 'action', label: 'Action' },
  { key: 'status', label: 'Status' },
] as const;

/** Printed beneath box 4 on the sheet. */
export const ICS232A_SITE_INDEX_NOTE =
  'This form is designed to be posted next to the Situation Map. Use additional sheets as needed.';
